import type { RegisterOptions } from 'react-hook-form'
import { parseRegExpLiteral } from 'regexpp'


export function getInputRules(setting: IApplicationSettingOptions): RegisterOptions {
  const rules: RegisterOptions = {}

  if(setting.required && setting.type !== 'boolean') {
    rules.required = 'Field is required'
  }

  if(setting.pattern) {
    let value
    try {
      if(setting.pattern && setting.pattern[0] === '/' && (setting.pattern.endsWith('/i') || setting.pattern.endsWith('/'))) {
        value = new RegExp(parseRegExpLiteral(setting.pattern).pattern.raw, parseRegExpLiteral(setting.pattern).flags.raw)
      } else {
        value = new RegExp(parseRegExpLiteral(`/${setting.pattern}/`).pattern.raw)
      }
    } catch (e) {
      value = new RegExp(setting.pattern)
    }
    rules.pattern = {
      value,
      message: 'RegEx validation failed',
    }
  }

  if(setting.enum) {
    rules.validate = {
      isInEnum: (value) => setting.enum && value ? setting.enum.includes(value) || 'Invalid selection. Please choose a valid option from the dropdown list.' : undefined,
    }
  }

  if(setting.minLength !== undefined) {
    rules.minLength = {
      value: setting.minLength,
      message: `Must be ${setting.minLength} characters or more`,
    }
  }

  if(setting.maxLength !== undefined) {
    rules.maxLength = {
      value: setting.maxLength,
      message: `'Must not exceed ${setting.maxLength} characters'`,
    }
  }

  if(setting.minimum !== undefined) {
    rules.min = {
      value: setting.minimum,
      message: `Please enter a value at or greater than ${setting.minimum}`,
    }
  }

  if(setting.maximum !== undefined) {
    rules.max = {
      value: setting.maximum,
      message: `Please enter a value at or below ${setting.maximum}`,
    }
  }

  return rules
}
